<template>
  <div class="breadcrumbs">
    <v-icon class="home-icon">mdi-home</v-icon>
    <div class="sub" v-for="item in breadcrumbs" :key="item">
      <img src="@/assets/chevron-right.svg" class="mx-3" />
      <a href="#">{{ item }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: {
    breadcrumbs: Array
  }
};
</script>

<style scoped lang="scss" src="./Breadcrumbs.scss"></style>
